import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Configuration, DocumentsApi } from '@inosio/payments-sdk';
import { uploadDocuments, handleUploadDocumentsSuccess, handleUploadDocumentsFailed, deleteDocument, handleDeleteDocumentSuccess, handleDeleteDocumentFailed } from './documentSlice';
import { IpaUserExtended, selectCurrentUser } from '../auth/authSlice';

const { REACT_APP_IPA_BASE_PATH } = process.env;

export function requestUploadDocuments(accessToken: string, belongsToEntityUuid: string, documents: Array<any>, documentType: string) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken,
  });

  const ipaDocumentAPI = new DocumentsApi(apiConfig);
  return ipaDocumentAPI.uploadFile(belongsToEntityUuid, documentType, documents);
}

export function requestDeleteDocument(accessToken: string, documentUuid: string) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken,
  });

  const ipaDocumentAPI = new DocumentsApi(apiConfig);
  return ipaDocumentAPI.deleteFile(documentUuid);
}

// export function requestGetDocuments(accessToken: string, documentOwnerUuid: string, documentTypeId?: string[]) {
//   const apiConfig = new Configuration({
//     basePath: REACT_APP_IPA_BASE_PATH,
//     accessToken,
//   });

//   const ipaDocumentAPI = new DocumentsApi(apiConfig);
//   return ipaDocumentAPI.getDocuments(documentOwnerUuid, documentTypeId);
// }

export function* handleUploadDocuments(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const uploadDocumentsResponse: AxiosResponse<any> = yield call(requestUploadDocuments, currentUser.accessToken, action.payload.belongsToEntityUuid, action.payload.documents, action.payload.documentType);
    const { data } = uploadDocumentsResponse;
    if(!data?.files?.length){
      //not even one document came back successful.
      throw new Error("Document(s) failed up to upload.");
    }
    yield put(handleUploadDocumentsSuccess(data.files));
  } catch (error: any) {
    yield put(
      handleUploadDocumentsFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleDeleteDocument(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    yield call(requestDeleteDocument, currentUser.accessToken, action.payload);

    yield put(handleDeleteDocumentSuccess());
  } catch (error: any) {
    yield put(
      handleDeleteDocumentFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

// export function* handleGetDocuments(action: any) {
//   try {
//     const currentUser:IpaUserExtended= yield select(selectCurrentUser);
//     const getDocumentsResponse: AxiosResponse<ReadDocumentDto[]> = yield call(requestGetDocuments, currentUser.access_token, action.payload.belongsToEntityUuid, action.payload.documentTypeIds);
//     const { data } = getDocumentsResponse;

//     yield put(setDocuments(data));
//   } catch (error: any) {
//     yield put(
//       getDocumentsError({
//         message: error?.response?.data?.message,
//         statusCode: error?.response?.data?.statusCode,
//       }),
//     );
//   }
// }

export function* documentSaga() {
  yield takeLatest(uploadDocuments.type, handleUploadDocuments);
  yield takeLatest(deleteDocument.type, handleDeleteDocument);
  // yield takeLatest(getDocuments.type, handleGetDocuments);
}
